// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__BlMDn","modalFooterButton":"ModalNotes_modalFooterButton__2_kym"};